import { TestTd } from "@/components/tables/commers/tabletest/test.td";
import { horizontalListSortingStrategy, SortableContext } from "@dnd-kit/sortable";
import { Row } from "@tanstack/react-table";
import { VirtualItem, Virtualizer } from "@tanstack/react-virtual";

interface TanstackTableRowProps<T extends object, K extends object> {
  row: Row<T | K>;
  virtualRow: VirtualItem;
  rowVirtualizer: Virtualizer<HTMLDivElement, Element>;
  columnOrder: string[];
  height?: number;
}

export const TanstackTableRow = <T extends object, K extends object>({
  row,
  virtualRow,
  rowVirtualizer,
  columnOrder,
  height = 80,
}: TanstackTableRowProps<T, K>) => {
  return (
    <div
      data-index={virtualRow.index}
      ref={(node) => rowVirtualizer.measureElement(node)}
      key={row.id}
      style={{
        display: "flex",
        position: "absolute",
        transform: `translateY(${virtualRow.start}px)`,
        width: "100%",
        height: `${height}px`,
      }}
      onClick={() => {
        if (row.getCanExpand()) {
          row.toggleExpanded();
        }
      }}
      className={`items-center cursor-pointer border-b transition-colors hover:bg-accent/50`}
    >
      {row.getVisibleCells().map((cell) => (
        <SortableContext key={cell.id} items={columnOrder} strategy={horizontalListSortingStrategy}>
          <TestTd key={cell.id} cell={cell} />
        </SortableContext>
      ))}
    </div>
  );
};
